<section class="calendar-event-dialog" aria-label="Calendar event dialog">
  <header class="calendar-event-dialog__header">
    <div>
      <p class="calendar-event-dialog__eyebrow">Calendar</p>
      <h2>
        @if (data.mode === 'edit') {
          Edit event
        } @else {
          New event
        }
      </h2>
    </div>

    <button type="button" mat-icon-button aria-label="Close event dialog" (click)="close()">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </header>

  <form class="" [formGroup]="form" (ngSubmit)="submit()" novalidate style="margin-top: 10px;">

    <div style="display: flex; flex-direction: row; gap: 12px">

      <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Type</mat-label>
      <mat-select formControlName="eventType">
        <mat-option value="in_person">In person</mat-option>
        <mat-option value="online">Online ({{ brand.name }})</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Title</mat-label>
      <input matInput type="text" formControlName="title" />
      @if (form.controls.title.hasError('required') && form.controls.title.touched) {
        <mat-error>Title is required.</mat-error>
      }
      @if (form.controls.title.hasError('minlength') && form.controls.title.touched) {
        <mat-error>Use at least 2 characters.</mat-error>
      }
    </mat-form-field>

    </div>

    <div style="display: flex; flex-direction: row; gap: 12px">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Start</mat-label>
        <input matInput type="datetime-local" formControlName="startAt" />
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>End</mat-label>
        <input matInput type="datetime-local" formControlName="endAt" />
      </mat-form-field>
    </div>


    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Location</mat-label>
      <input matInput type="text" formControlName="location" />
      @if (form.controls.location.hasError('required') && form.controls.location.touched) {
        <mat-error>Location is required for in-person events.</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Description (optional)</mat-label>
      <textarea matInput rows="2" formControlName="description"></textarea>
    </mat-form-field>

    <mat-divider></mat-divider>

    <h3>Attendees </h3>

    <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>People in your company</mat-label>
        <mat-select multiple formControlName="attendeeUserIds">
          @for (user of selectableCompanyUsers(); track user.id) {
            <mat-option [value]="user.id">{{ user.name }} ({{ user.email }})</mat-option>
          }
        </mat-select>
    </mat-form-field>

    <div style="display: flex; flex-direction: row; gap: 12px; justify-content: center; align-items: center;">

      <mat-form-field appearance="outline" style="flex: 1;">
        <mat-label>External attendee name</mat-label>
        <input matInput type="text" formControlName="externalName" />
        @if (form.controls.externalName.hasError('required') && form.controls.externalName.touched) {
          <mat-error>Name is required.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" style="flex: 1;">
          <mat-label>External attendee email</mat-label>
          <input matInput type="email" formControlName="externalEmail" />
          @if (form.controls.externalEmail.hasError('email') && form.controls.externalEmail.touched) {
            <mat-error>Enter a valid email.</mat-error>
          }
          @if (form.controls.externalEmail.hasError('required') && form.controls.externalEmail.touched) {
            <mat-error>Email is required.</mat-error>
          }
        </mat-form-field>
        <button type="button" mat-stroked-button color="primary" (click)="addExternalAttendee()">Add</button>

    </div>

    <div class="calendar-event-dialog__external-chips-scroll" aria-label="External attendees">
      <mat-chip-set class="calendar-event-dialog__external-chips">
        @for (attendee of externalAttendees(); track attendee.email) {
          <mat-chip-row [removable]="true" (removed)="removeExternalAttendee(attendee.email)">
            {{ attendee.name ? (attendee.name + ' • ') : '' }}{{ attendee.email }}
            <button matChipRemove type="button" aria-label="Remove external attendee">
              <mat-icon aria-hidden="true">close</mat-icon>
            </button>
          </mat-chip-row>
        }
      </mat-chip-set>
    </div>

    <div style="display: flex; flex-direction: row; gap: 12px; margin-top: 10px;">
      <mat-form-field appearance="outline">
        <mat-label>Repeat</mat-label>
        <mat-select formControlName="recurrenceFrequency">
          <mat-option value="none">Does not repeat</mat-option>
          <mat-option value="daily">Daily</mat-option>
          <mat-option value="weekly">Weekly</mat-option>
          <mat-option value="monthly">Monthly</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Every</mat-label>
        <input matInput type="number" min="1" formControlName="recurrenceInterval" />
      </mat-form-field>

      <mat-form-field appearance="outline">
      <mat-label>Repeat until</mat-label>
      <input matInput type="date" formControlName="recurrenceUntil" />
      @if (form.controls.recurrenceUntil.hasError('required') && form.controls.recurrenceUntil.touched) {
        <mat-error>End date is required for recurring events.</mat-error>
      }
    </mat-form-field>
    </div>

    <div class="calendar-event-dialog__actions">
      @if (data.mode === 'edit') {
        <button type="button" mat-button color="warn" (click)="delete()">Delete</button>
      }
      <span class="calendar-event-dialog__spacer"></span>
      <button type="button" mat-stroked-button color="primary" (click)="close()">Cancel</button>
      <button type="submit" mat-flat-button color="primary">
        @if (data.mode === 'edit') {
          Save
        } @else {
          Create
        }
      </button>
    </div>
  </form>
</section>
